// extracted by mini-css-extract-plugin
module.exports = {"eliteStoresWrapper":"_1IEzI","title":"_1ICqH","rightLeaf":"_3BJty","storeCard":"_3fmw_","storeImg":"YutkI","location":"EoXFi","locationTitle":"_17X0c"};